import { installGtmDataLayer } from '../utils/gtmDataLayer';
import { LOCATION_CHANGE } from 'connected-react-router';
import { handleEvent } from '../utils/Analytics/AnalyticsManager';
import { getRoute, getRouteAnalytics } from 'utils/routes';
import { EVENTS_MAP } from '../utils/Analytics/constants';

const isPromiseObject = (payload: any) => {
  return payload && Object.prototype.toString.call(payload) === '[object Promise]';
};

export const analyticsMiddleware = (store: { getState: () => State.Root }) => {
  installGtmDataLayer(store);

  return (next: any) => async (action: any) => {
    const { type, payload } = action;
    let isAnalyticsEnabledRoute = false;
    let newType = type;
    const nextAction = await next(action);

    const isLocationChangeEvent: boolean = type === LOCATION_CHANGE;
    if (isLocationChangeEvent && Boolean(payload?.location?.pathname)) {
      const route = getRoute(payload.location.pathname) as string;
      isAnalyticsEnabledRoute = getRouteAnalytics(route) && !payload.location.hash;

      if (!isAnalyticsEnabledRoute) {
        newType = Object.keys(EVENTS_MAP).find(event => EVENTS_MAP[event].route === route);

        if (!newType || payload?.isFirstRendering === false) {
          return nextAction;
        }
      }
    }

    if (typeof payload !== 'function' && !isPromiseObject(payload)) {
      handleEvent(payload, newType, store.getState());
    }

    return nextAction;
  };
};

export { analyticsLayer } from '../utils/Analytics/analyticsLayer';